import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

const bold = { b: (chunks: React.ReactNode) => <b>{chunks}</b> }

const InherentRiskMethodologyContent: React.FC = () => {
  const { formatMessage } = useIntl()

  return (
    <Stack spacing={4}>
      <Typography variant="h3">{formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.title' })}</Typography>

      <Stack spacing={1}>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.intro1' })}
        </Typography>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.intro2' })}
        </Typography>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.intro3' })}
        </Typography>
      </Stack>

      <Stack spacing={1}>
        <Typography variant="h5">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.indices.title' })}
        </Typography>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.indices.countryRisk' }, bold)}
        </Typography>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.indices.industryRisk' }, bold)}
        </Typography>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.indices.sources' })}
        </Typography>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.indices.nace' })}
        </Typography>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.indices.levelsLeadIn' }, bold)}
        </Typography>
        <Box component="ul" sx={{ pl: 3, mt: 0.5 }}>
          <Typography component="li" variant="body1">
            {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.indices.levelLow' }, bold)}
          </Typography>
          <Typography component="li" variant="body1">
            {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.indices.levelMedium' }, bold)}
          </Typography>
          <Typography component="li" variant="body1">
            {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.indices.levelHigh' }, bold)}
          </Typography>
        </Box>
      </Stack>

      <Stack spacing={1}>
        <Typography variant="h5">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.calculation.title' })}
        </Typography>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.calculation.intro' })}
        </Typography>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.calculation.formula' }, bold)}
        </Typography>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.calculation.weighting' })}
        </Typography>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.calculation.contextual' })}
        </Typography>
      </Stack>

      <Stack spacing={1}>
        <Typography variant="h5">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.levels.title' })}
        </Typography>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.levels.intro' })}
        </Typography>
        <Box component="ul" sx={{ pl: 3, mt: 0.5 }}>
          <Typography component="li" variant="body1">
            {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.levels.low' }, bold)}
          </Typography>
          <Typography component="li" variant="body1">
            {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.levels.medium' }, bold)}
          </Typography>
          <Typography component="li" variant="body1">
            {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.levels.high' }, bold)}
          </Typography>
          <Typography component="li" variant="body1">
            {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.levels.extreme' }, bold)}
          </Typography>
        </Box>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.levels.example' }, bold)}
        </Typography>
      </Stack>

      <Box
        component="img"
        src="/img/risk-indices/inherent-risk-matrix.png"
        alt={formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.matrixAlt' })}
        sx={{ width: '100%', maxWidth: '600px', height: 'auto', borderRadius: 1, objectFit: 'contain' }}
      />

      <Stack spacing={1}>
        <Typography variant="h5">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.review.title' })}
        </Typography>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.review.description' })}
        </Typography>
      </Stack>

      <Stack spacing={1}>
        <Typography variant="h5">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.finalNote.title' })}
        </Typography>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.finalNote.paragraph1' })}
        </Typography>
        <Typography variant="body1">
          {formatMessage({ id: 'riskScreeningConfig.inherentRiskMethodology.finalNote.paragraph2' })}
        </Typography>
      </Stack>
    </Stack>
  )
}

export default InherentRiskMethodologyContent
